import { Component, Input, TemplateRef, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { TreeViewComponent } from './tree-view.component';
import { DraggableDirective } from '../draggable';
import { TreePanelComponent } from './tree-panel.component';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 're-tree-node,[reTreeNode]',
  template: "\n    <div class=\"node-item {{nodeCssClass}}\" reDraggable=\"re:node-item-drop\" [disabled]=\"!allowDraggable\" [dragData]=\"{node: node, parent: parentNode}\"><div class=\"node-item-panel\"><i class=\"node-expend-icon {{getNodeExpendIcon()}}\" (click)=\"onExpendedIconClick($event)\"></i><div class=\"node-item-content\" #nodeItemContent reDroppable=\"re:node-item-drop\" (onDrop)=\"onDropNodeItem($event)\" (onDragEnter)=\"onDragEnter()\" (onDragLeave)=\"onDragLeave()\" [acceptDrop]=\"isAcceptDrop\"><div class=\"node-check-box\"><re-checkbox *ngIf=\"checkable\" [(ngModel)]=\"node.$check\" label=\"\" (valueChange)=\"nodeItemCheckedChange($event)\"></re-checkbox></div><ng-container *ngIf=\"!nodeItemTemplate\"><span class=\"node-text\" [ngClass]=\"{'bg-primary': node.$select}\" (click)=\"onNodeItemClick($event)\" (dblclick)=\"onNodeItemDbClicked($event)\"><i *ngIf=\"iconField && node[iconField]\" class=\"node-icon {{node[iconField]}}\"></i> {{node[textField] || ''}} <span class=\"loading\" *ngIf=\"isLoading\"><i class=\"{{loadingIcon}}\"></i></span></span><div class=\"toolbar\"><ng-template *ngIf=\"nodeItemToolbarTemplate\" [ngTemplateOutlet]=\"nodeItemToolbarTemplate\" [ngTemplateOutletContext]=\"{$implicit: node, parentNode:parentNode, tree: this}\"></ng-template></div></ng-container><ng-container *ngIf=\"nodeItemTemplate\"><ng-template *ngIf=\"nodeItemTemplate\" [ngTemplateOutlet]=\"nodeItemTemplate\" [ngTemplateOutletContext]=\"{$implicit: node,  parentNode:parentNode, tree: this }\"></ng-template></ng-container></div></div><re-tree-panel *ngIf=\"node.children && node.children.length && node.$expend\" class=\"children-view\" [treeData]=\"node.children\" [textField]=\"textField\" [valueField]=\"valueField\" [iconField]=\"iconField\" [checkable]=\"checkable\" [lazyLoad]=\"lazyLoad\" [loadingIcon]=\"loadingIcon\" [loadChildren]=\"loadChildren\" [allowDraggable]=\"allowDraggable && !isInDraggle\" [allowMutipleSelected]=\"allowMutipleSelected\" [parentNode]=\"node\" [nodeItemTemplate]=\"nodeItemTemplate\" [nodeItemToolbarTemplate]=\"nodeItemToolbarTemplate\" [leafIcon]=\"leafIcon\" [expendIcon]=\"expendIcon\" [collapseIcon]=\"collapseIcon\" (nodeItemCheckedChanged)=\"onChildrenNodeCheckedChange($event)\"></re-tree-panel></div>\n  ",
  styles: ["\n    .node-item{position:relative}.node-item-content ::ng-deep{display:inline-block}.node-item-content ::ng-deep .node-icon{margin-right:2px}.node-item-content ::ng-deep .node-text{cursor:pointer;padding:2px;border-radius:4px}.node-item-content ::ng-deep .node-text:not(.bg-primary):hover{border:1px dashed #ddd}.node-expend-icon{cursor:pointer}.drop-node-enter{border:1px solid #2196f3}.node-check-box,.toolbar{display:inline-block}.expend-icon{cursor:pointer}.node-check-box .checkbox{margin:0}.children-view{display:block;padding:10px 1.5rem;border-left:1px dashed #ddd;margin-left:5px}.children-view .node-item{position:relative}.children-view .node-item:before{content:' ';position:absolute;left:-1.5rem;border-top:1px dashed #ddd;display:inline-block;width:1.5rem;height:1px;top:10px}.loading{-webkit-animation:loadingAnimation 1.5s infinite alternate;-moz-animation:loadingAnimation 1.5s infinite alternate;-ms-animation:loadingAnimation 1.5s infinite alternate;-o-animation:loadingAnimation 1.5s infinite alternate;animation:loadingAnimation 1.5s infinite alternate}@-webkit-keyframes loadingAnimation{50%{color:#ff9800}100%{color:#4caf50}}\n  "],
  exportAs: 'treeNode'
})
export class TreeNodeComponent {
  @Input() node: any;
  @Input() parentNode: any;
  @Input() valueField: string;
  @Input() textField: string;
  @Input() nodeCssClass: string;
  @Input() iconField: string;
  @Input() checkable = false;
  @Input() lazyLoad = false;
  @Input() loadingIcon: string;
  @Input() loadChildren: (parent: any) => Observable<any[]>;
  @Input() allowDraggable = false;
  @Input() allowMutipleSelected = false;
  @Input() nodeItemTemplate: TemplateRef<any>;
  @Input() nodeItemToolbarTemplate: TemplateRef<any>;
  @Input() leafIcon;
  @Input() expendIcon;
  @Input() collapseIcon;
  @ViewChild('nodeItemContent') nodeItemContent: ElementRef;
  isLoading: boolean;
  isAcceptDrop = ($event) => {
    const dropData = JSON.parse($event.dataTransfer.getData(DraggableDirective.DRAGGABLE_DATA_KEY));
    if (!dropData.data.node) {
      return false;
    }

    if (this.isNodeMyself(dropData)) {
      return false;
    }

    if (this.isDescendant(dropData.data.node, this.node)) {
      return false;
    }

    return true;
  }

  constructor(private treeViewComponent: TreeViewComponent,
              private treePanelComponent: TreePanelComponent,
              private renderer: Renderer2) {

  }


  getNodeExpendIcon() {
    if (this.isLeaf()) {
      return this.leafIcon;
    }

    return this.node.$expend ? this.expendIcon : this.collapseIcon;
  }

  onExpendedIconClick($event) {
    $event.stopPropagation();

    if (this.isLeaf() || this.isLoading) {
      return;
    }

    let loadObservable = of(null);
    if (this.lazyLoad && !this.node.$loaded) {
      this.isLoading = true;
      loadObservable = this.loadChildren(this.node)
        .pipe(map((children) => {
          this.node.children = children || [];
          this.node.$loaded = true;
        }));
    }

    loadObservable.subscribe(() => {
      this.isLoading = false;
      this.node.$expend = !this.node.$expend;
      this.treeViewComponent.onNodeItemExpended(this.node);
    }, () => {
      this.isLoading = false;
    });
  }

  onNodeItemClick($event) {
    $event.stopPropagation();
    this.node.$select = !this.node.$select;
    this.treeViewComponent.onNodeItemClicked(this.node);
  }

  onNodeItemDbClicked() {
    this.treeViewComponent.onNodeItemDbClicked(this.node);
  }

  nodeItemCheckedChange(checked) {
    this.changeChildrenChecked(this.node.children, checked);
    this.treePanelComponent.onNodeItemCheckedChanged(this.node);
  }

  onChildrenNodeCheckedChange(node) {
    this.node.$check = !this.node.children.some((item) => !item.$check);
    this.treePanelComponent.onNodeItemCheckedChanged(node);
  }

  isLeaf() {
    if (this.lazyLoad && !this.node.$loaded) {
      return false;
    }

    return !this.node.children || !this.node.children.length;
  }

  onDragEnter() {
    this.renderer.addClass(this.nodeItemContent.nativeElement, 'drop-node-enter');
  }

  onDragLeave() {
    setTimeout(() => {
      this.renderer.removeClass(this.nodeItemContent.nativeElement, 'drop-node-enter');
    });
  }

  onDropNodeItem($event) {
    const dropData = JSON.parse($event.dataTransfer.getData(DraggableDirective.DRAGGABLE_DATA_KEY));
    if (dropData.data.node && !this.isNodeMyself(dropData)) {
      this.treeViewComponent.onNodeItemDroped({ target: this.node, data: dropData });
    }
    setTimeout(() => {
      this.renderer.removeClass(this.nodeItemContent.nativeElement, 'drop-node-enter');
    }, 0);
  }

  private isNodeMyself(dropData: any) {
    return this.node[this.valueField] === dropData.data.node[this.valueField];
  }

  private isDescendant(parent, target) {
    if (!parent) {
      return false;
    }

    return (parent.children || []).some((nodeItem) => {
      return nodeItem[this.valueField] === target[this.valueField] || this.isDescendant(nodeItem, target);
    });
  }

  private changeChildrenChecked(nodes: any[], checked) {
    if (!nodes) {
      return;
    }

    nodes.forEach((node) => {
      node.$check = checked;
      this.changeChildrenChecked(node.children, checked);
    });
  }

}
